import React, { useState, useEffect } from "react";

import { DialogContent } from "@mui/material";
import {
  Collapse,
  Box,
  Drawer,
  BottomNavigation,
  BottomNavigationAction,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import {
  Language,
  Menu as MenuIcon,
  Cancel as CancelIcon
} from "@mui/icons-material";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

import SupportModal from "../../container/SupportModal/Modal";
import Modal from "../../HOC/modal/Modal";
import esFlag from "../../assets/images/flag-es.svg";
import enFlag from "../../assets/images/flag-uk.svg";
import pgFlag from "../../assets/images/flag-pg.svg";
import { ReactComponent as CasinoIcon } from "../../assets/images/Casino.svg";
import { ReactComponent as LobbyIcon } from "../../assets/images/Lobby_icon.svg";
import { ReactComponent as Favorites } from "../../assets/images/Favorites.svg";
import { ReactComponent as Providers } from "../../assets/images/provider.svg";
import { ReactComponent as OnFire } from "../../assets/images/OnFire.svg";
import { ReactComponent as NewGames } from "../../assets/images/NewGames.svg";
import { ReactComponent as Slots } from "../../assets/images/Slots.svg";
import { ReactComponent as Poker } from "../../assets/images/Poker.svg";
import { ReactComponent as Baccarat } from "../../assets/images/Baccarat.svg";
import { ReactComponent as Roulette } from "../../assets/images/Roulette.svg";
import { ReactComponent as Sports } from "../../assets/images/SportsIcon.svg";
import { ReactComponent as Sportsbook } from "../../assets/images/SportsBook.svg";
import { ReactComponent as Football } from "../../assets/images/Football.svg";
import { ReactComponent as Basketball } from "../../assets/images/Basketball.svg";
import { ReactComponent as Tennis } from "../../assets/images/Tennis.svg";
import { ReactComponent as AmericanFootball } from "../../assets/images/American_Football.svg";
import { ReactComponent as Formula1 } from "../../assets/images/Formula_1.svg";
import { ReactComponent as Baseball } from "../../assets/images/Baseball.svg";
import { ReactComponent as EFootball } from "../../assets/images/EFootball.svg";
import { ReactComponent as MMA } from "../../assets/images/MMA.svg";
import { ReactComponent as Bonus } from "../../assets/images/Bonus.svg";
// import { ReactComponent as Blog } from "../../assets/images/Blog.svg";
// import { ReactComponent as ResponsibleGaming } from "../../assets/images/Responsible_Gaming.svg";
import { ReactComponent as Support } from "../../assets/images/Support.svg";
import { ReactComponent as LiveCasinoMob } from "../../assets/images/LiveCasinoMob.svg";
import { ReactComponent as Frame } from "../../assets/images/Frame 37.svg";

// helper to resolve localized routes (supports string or { en, es } objects)
const resolveTo = (to) => {
  if (!to) return undefined;
  if (typeof to === "string") return to;
  return to[i18n.language] || to.en || Object.values(to)[0];
};

// Responsive hook: treat mobile + tablet (<=1024) as "mobile nav" screens
function useIsMobileNav() {
  const [isMobileNav, setIsMobileNav] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 1024 : false
  );
  useEffect(() => {
    const handler = () => setIsMobileNav(window.innerWidth <= 1024);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobileNav;
}

export default function MobileMenuPanel() {
  const isMobileNav = useIsMobileNav(); // <=1024px
  const { t } = useTranslation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openCasino, setOpenCasino] = useState(false);
  const [openSports, setOpenSports] = useState(false);

  const casinoItems = [
    {
      label: t("NEW_SIDEBAR.LOBBY") || "Lobby",
      icon: LobbyIcon,
      to: "/casino/casino-lobby"
    },
    {
      label: t("NEW_SIDEBAR.FAVORITES") || "Favorites",
      icon: Favorites,
      to: "/casino/casino_favorites"
    },
    {
      label: t("NEW_SIDEBAR.PROVIDERS") || "Providers",
      icon: Providers,
      to: "/casino/casinoProvider"
    },
    {
      label: t("NEW_SIDEBAR.ON_FIRE") || "On Fire",
      icon: OnFire,
      to: "/casino/on-fire"
    },
    {
      label: t("NEW_SIDEBAR.NEW_GAMES") || "New Games",
      icon: NewGames,
      to: "/casino/nuevos-juegos"
    },
    {
      label: t("NEW_SIDEBAR.LIVE_CASINO") || "Live Casino",
      icon: LiveCasinoMob,
      to: "/casino/casinoLive"
    },
    {
      label: t("NEW_SIDEBAR.SLOTS") || "Slots",
      icon: Slots,
      to: "/casino/slotGame"
    },
    {
      label: t("NEW_SIDEBAR.POKER") || "Poker",
      icon: Poker,
      to: "/casino/poker"
    },
    {
      label: t("NEW_SIDEBAR.BACCARAT") || "Baccarat",
      icon: Baccarat,
      to: "/casino/baccarat"
    },
    {
      label: t("NEW_SIDEBAR.ROULETTE") || "Roulette",
      icon: Roulette,
      to: "/casino/ruleta"
    }
  ];

  const sportsItems = [
    {
      label: t("NEW_SIDEBAR.FOOTBALL") || "Football",
      icon: Football,
      to: { en: "/sports/Soccer", es: "/sports/Fútbol" }
    },
    {
      label: t("NEW_SIDEBAR.BASKETBALL") || "Basketball",
      icon: Basketball,
      to: { en: "/sports/Basketball", es: "/sports/Baloncesto" }
    },
    {
      label: t("NEW_SIDEBAR.TENNIS") || "Tennis",
      icon: Tennis,
      to: { en: "/sports/Tennis", es: "/sports/Tenis" }
    },
    {
      label: t("NEW_SIDEBAR.AMERICAN_FOOTBALL") || "American Football",
      icon: AmericanFootball,
      to: { en: "/sports/Football", es: "/sports/Fútbol-Americano" }
    },
    {
      label: t("NEW_SIDEBAR.MOTOR_RACING") || "Motor Racing",
      icon: Formula1,
      to: { en: "/sports/Motor-Racing", es: "/sports/Automovilismo-deportivo" }
    },
    {
      label: t("NEW_SIDEBAR.BASEBALL") || "Baseball",
      icon: Baseball,
      to: { en: "/sports/Baseball", es: "/sports/Béisbol-" }
    },
    {
      label: t("NEW_SIDEBAR.E_FOOTBALL") || "E-Football",
      icon: EFootball,
      to: { en: "/sports/Virtual-Soccer", es: "/sports/Fútbol-Virtual" }
    },
    { label: t("NEW_SIDEBAR.MMA") || "MMA", icon: MMA, to: "/sports/MMA" }
  ];

  const [openSupportModal, setOpenSupportModal] = useState(false);

  const otherItems = [
    {
      label: t("NEW_SIDEBAR.BONUS") || "Bonificaciones",
      icon: Bonus,
      to: "/user/bonus"
    },
    // { label: t("NEW_SIDEBAR.BLOG") || "Blog", icon: Blog, to: "/blog" },
    // { label: t("NEW_SIDEBAR.RESPONSIBLE_GAMING") || "Responsible Gaming", icon: ResponsibleGaming, to: "/responsible-gaming" },
    {
      label: t("NEW_SIDEBAR.SUPPORT") || "Soporte",
      icon: Support,
      onClick: () => setOpenSupportModal(true)
    }
  ];

  function renderLanguageMenu() {
    const isES = i18n.language === "es";
    const isEN = i18n.language === "en";
    const isPT = i18n.language === "pt";

    return (
      <Box
        sx={{
          bgcolor: "#0A2024",
          borderRadius: "14px",
          overflow: "hidden",
          mb: 35
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1.2,
            display: "flex",
            alignItems: "center",
            gap: 1.2,
            color: "#fff",
            fontWeight: 700,
            fontSize: 15.5
          }}
        >
          <Language sx={{ fontSize: 20 }} />
          <span>{t("NEW_SIDEBAR.LANGUAGE")}</span>
        </Box>
        <Box
          sx={{
            bgcolor: "#0A2024",
            px: 1,
            py: 0.8
          }}
        >
          {/* Español */}
          <Box
            onClick={() => i18n.changeLanguage("es")}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.2,
              px: 1.5,
              py: 1,
              borderRadius: 2,
              cursor: "pointer",
              fontSize: 15.2,
              fontWeight: isES ? 700 : 500,
              color: isES ? "#FF014D" : "#BBBBBB"
            }}
          >
            <img
              src={esFlag}
              alt="Español"
              width={22}
              height={15}
              style={{ borderRadius: 3 }}
            />
            <span>{t("NEW_SIDEBAR.SPANISH")}</span>
          </Box>

          {/* English */}
          <Box
            onClick={() => i18n.changeLanguage("en")}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.2,
              px: 1.5,
              py: 1,
              borderRadius: 2,
              cursor: "pointer",
              fontSize: 15.2,
              fontWeight: isEN ? 700 : 500,
              color: isEN ? "#FF014D" : "#BBBBBB"
            }}
          >
            <img
              src={enFlag}
              alt="English"
              width={22}
              height={15}
              style={{ borderRadius: 3 }}
            />
            <span>{t("NEW_SIDEBAR.ENGLISH")}</span>
          </Box>

          {/* Portuguese */}
          <Box
            onClick={() => i18n.changeLanguage("pt")}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.2,
              px: 1.5,
              py: 1,
              borderRadius: 2,
              cursor: "pointer",
              fontSize: 15.2,
              fontWeight: isPT ? 700 : 500,
              color: isPT ? "#FF014D" : "#BBBBBB"
            }}
          >
            <img
              src={pgFlag}
              alt="Portuguese"
              width={22}
              height={15}
              style={{ borderRadius: 3 }}
            />
            <span>{t("NEW_SIDEBAR.PORTUGUESE")}</span>
          </Box>
        </Box>
      </Box>
    );
  }

  function MenuCard({ children, onClick, style }) {
    return (
      <Box
        sx={{
          bgcolor: "#0A2024",
          borderRadius: 2.5,
          mb: 1.4,
          px: 2,
          py: 1.1,
          fontSize: 17,
          fontWeight: 700,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between !important",
          boxShadow: "none",
          minHeight: 50,
          cursor: onClick ? "pointer" : "inherit",
          ...style
        }}
        onClick={onClick}
      >
        {children}
      </Box>
    );
  }

  // hide only on desktop; show on mobile + tablet
  if (!isMobileNav) return null;

  return (
    <>
      <BottomNavigation
        showLabels
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1201,
          bgcolor: "#0A2024",
          borderTop: "1px solid #0A2024",
          height: 60,
          display: "flex",
          justifyContent: "space-between",
          "& .MuiBottomNavigationAction-root": {
            flex: 1,
            maxWidth: "none",
            minWidth: 0,
            padding: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px"
          },
          "& .MuiBottomNavigationAction-label": {
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.2,
            margin: 0
          },
          "& .MuiBottomNavigationAction-root svg": {
            width: 22,
            height: 22,
            display: "block"
          }
        }}
      >
        <BottomNavigationAction
          icon={drawerOpen ? <CancelIcon /> : <MenuIcon />}
          label={drawerOpen ? "Menu" : "Menu"}
          onClick={() => setDrawerOpen((open) => !open)}
        />
        <BottomNavigationAction
          icon={<LobbyIcon />}
          label="Lobby"
          component={NavLink}
          to="/casino/casino-lobby"
        />
        <BottomNavigationAction
          icon={<LiveCasinoMob />}
          label={t("NEW_SIDEBAR.LIVE_CASINO")}
          component={NavLink}
          to="/casino/casinoLive"
        />
        <BottomNavigationAction
          icon={<Sportsbook />}
          label={t("HEADER.SPORTS")}
          component={NavLink}
          to="/sports"
        />
      </BottomNavigation>
      <Drawer
        anchor="bottom"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 18,
            borderTopRightRadius: 18,
            bgcolor: "#101211 !important",
            color: "#fff",
            pb: 3,
            maxHeight: "87vh"
          }
        }}
      >
        <Box
          sx={{
            p: 3,
            pt: 2,
            overflowY: "auto",
            maxHeight: "calc(87vh - 20px)",
            bgcolor: "#101211 !important"
          }}
        >
          <MenuCard onClick={() => setOpenCasino((val) => !val)}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.3 }}>
              <CasinoIcon />
              <span style={{ fontSize: 15.8, fontWeight: 700 }}>Casino</span>
            </Box>
            <Box>
              <Frame
                open={openCasino}
                style={{
                  transform: openCasino ? "rotate(0deg)" : "rotate(-180deg)",
                  transformOrigin: "11px 11px"
                }}
              />
            </Box>
          </MenuCard>

          <Collapse in={openCasino}>
            <List disablePadding>
              {casinoItems.map((item) => (
                <ListItem
                  button
                  key={item.label}
                  component={NavLink}
                  to={resolveTo(item.to)}
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: 600,
                    fontSize: 16
                  }}
                  onClick={() => setDrawerOpen(false)}
                >
                  <ListItemIcon sx={{ color: "#2F7379", minWidth: 36 }}>
                    <item.icon />
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      noWrap: true,
                      sx: {
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontWeight: 600,
                        fontSize: 15.6,
                        color: "#FFFFFF"
                      }
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Collapse>

          <MenuCard onClick={() => setOpenSports((val) => !val)}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.3 }}>
              <Sports />
              <span style={{ fontSize: 15.8, fontWeight: 700 }}>Sports</span>
            </Box>
            <Box>
              <Frame
                open={openSports}
                style={{
                  transform: openSports ? "rotate(0deg)" : "rotate(-180deg)",
                  transformOrigin: "11px 11px"
                }}
              />
            </Box>
          </MenuCard>

          <Collapse in={openSports}>
            <List disablePadding>
              {sportsItems.map((item) => (
                <ListItem
                  button
                  key={item.label}
                  component={NavLink}
                  to={resolveTo(item.to)}
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: 600,
                    fontSize: 16
                  }}
                  onClick={() => setDrawerOpen(false)}
                >
                  <ListItemIcon sx={{ color: "#2F7379", minWidth: 36 }}>
                    <item.icon />
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      noWrap: true,
                      sx: {
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontWeight: 600,
                        fontSize: 15.6,
                        color: "#FFFFFF"
                      }
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Collapse>

          {otherItems.map((item) => (
            <MenuCard
              key={item.label}
              onClick={
                item.onClick
                  ? () => {
                      item.onClick();
                      setDrawerOpen(false);
                    }
                  : undefined
              }
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.3,
                  width: "100%"
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <item.icon />
                </Box>

                {item.to && !item.onClick ? (
                  <NavLink
                    to={resolveTo(item.to)}
                    style={{
                      color: "#fff",
                      textDecoration: "none",
                      width: "100%",
                      fontWeight: 700,
                      fontSize: 15.8
                    }}
                    onClick={() => setDrawerOpen(false)}
                  >
                    {item.label}
                  </NavLink>
                ) : (
                  <span
                    style={{
                      color: "#fff",
                      width: "100%",
                      fontWeight: 700,
                      fontSize: 15.8
                    }}
                  >
                    {item.label}
                  </span>
                )}
              </Box>
            </MenuCard>
          ))}

          {renderLanguageMenu()}
        </Box>
      </Drawer>
      <Modal
        isShowing={openSupportModal}
        maxWidth={"600px"}
        maxHeight={"90%"}
        content={
          <DialogContent>
            <SupportModal setModalopen={setOpenSupportModal} />
          </DialogContent>
        }
        hide={() => setOpenSupportModal(false)}
      />
    </>
  );
}
